import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './CircularProgressWithLabel.scss';

/**
 * The value of the progress indicator for the determinate variant.
 * Value between 0 and 100.
 * 
 * @param {{ value: number }} props 
 * @returns 
 */
export default function CircularProgressWithLabel(props) {
  return (
    <Box className="circular-progress-with-label--root">
      <CircularProgress variant="determinate" {...props} />
      <Box
        className="circular-progress-with-label--label-container"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
          className="circular-progress-with-label--label"
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}